/* istanbul ignore file */
export const COMPONENT_FILE_EXTENSION = '.js';
export const COMPONENT_FILE_LEGACY_EXTENSION = '.lum';
